import MBlocksDesigner from '@admin/components/mblocks_designer/wrapper'
import Translate from '@apps/maha/admin/components/translate'
import MJSONDesigner from '@admin/components/mjson_designer'
import { canAccess } from '@core/utils/access'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import React from 'react'

class Design extends React.Component {

  static contextTypes = {
    admin: PropTypes.object
  }

  static propTypes = {
    email_campaign: PropTypes.object
  }

  render() {
    const { email_campaign } = this.props
    return (
      <>
        { email_campaign.engine === 'mblocks' ?
          <MBlocksDesigner { ...this._getMBlocksDesigner() } /> :
          <MJSONDesigner { ...this._getMJSONDesigner() } />
        }
      </>
    )
  }

  _getMBlocksDesigner() {
    const { email_campaign } = this.props
    return {
      defaultValue: email_campaign.config,
      editable: _.includes(['active','draft','inactive'], email_campaign.status),
      endpoint: `/api/admin/campaigns/email/${email_campaign.id}`,
      email: email_campaign,
      program: email_campaign.program,
      tokens: this._getTokens()
    }
  }

  _getMJSONDesigner() {
    const { email_campaign } = this.props
    const { admin } = this.context
    return {
      editable: canAccess({ rights: { $allOf: ['campaigns:manage_email_campaigns'] } }, admin) && _.includes(['draft','scheduled'], email_campaign.status),
      endpoint: `/campaigns_email_campaigns/${email_campaign.id}`,
      root_route: `/campaigns/email/${email_campaign.id}/design`,
      type: 'email',
      versionable: false
    }
  }

  _getTokens() {
    return []
  }

  _getPaymentTokens(model) {
    return {
      title: 't(Payment Tokens)',
      tokens: [
        { name: 'Method', token: `${model}.payment_method` },
        { name: 'Amount', token: `${model}.payment_amount` },
        { name: 'Card', token: `${model}.payment_card` },
        { name: 'Summary', token: `${model}.payment_summary` }
      ]
    }
  }

}

const mapPropsToPanel = (props, context) => ({
  title: 't(Design)',
  component: <Design email_campaign={ props.email_campaign } />,
  ..._.includes(['draft','scheduled'], props.email_campaign.status) ? {
    tasks: {
      items: [
        {
          label: 't(Translate Campaign)',
          svg: 'flag',
          modal: <Translate entity_type='campaigns_email_campaigns' entity_id={ props.email_campaign.id } mjson_type='email' publish={ false } />
        }
      ]
    }
  } : {}
})

export default Panel(null, mapPropsToPanel)
